import Modal from 'react-bootstrap/Modal'
import Button from 'react-bootstrap/Button';

const AboutModal = function ({showSignal, handleCancel, config}) {

    return (
		<Modal show={showSignal.value} onHide={handleCancel}>
			<Modal.Header closeButton>
				<Modal.Title>About</Modal.Title>
			</Modal.Header>
			<Modal.Body>
				<strong>Version:&nbsp;</strong>{config.version}
				<br/>
				<br/>
				Copyright &#x00a9; {new Date().getFullYear()} Shift4 Corporation. All rights reserved. All other trademarks, product names, company names, and logos appearing on this Site/Application are the property of their respective owners.
			</Modal.Body>
			<Modal.Footer>
				<Button type="button" onClick={handleCancel}>Close</Button>
			</Modal.Footer>
		</Modal>
    )
}
export default AboutModal